module.exports = __webpack_public_path__ + "img/link.1bfcc62e.svg";